import { useState } from "react";

/**
 * The recording's original link: open it, or copy it. `label` shortens what
 * is shown; the link itself is always the full URL.
 */
export function SourceLink({ url, label }: { url: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard access can be refused; the prompt still lets them copy it.
      window.prompt("Copy the recording's link:", url);
    }
  }

  return (
    <span className="sourcelink">
      <a href={url} target="_blank" rel="noopener noreferrer" title={url}>{label ?? url}</a>
      <button type="button" className="linkbtn small" onClick={() => void copy()} aria-label="Copy the recording's link">
        {copied ? "Copied" : "Copy link"}
      </button>
    </span>
  );
}
